module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i9dE9"))).then(() => module.bundle.root('d0iPb'));